var Vendd = (function (Vendd) {
    'use strict';


    var model = null;
    var pending = false;

    Vendd.MessageBus.subscribe(Vendd.FilterProduct.Messages.GetModel, Vendd.FilterProduct, function(envelope) {
        if (pending === true) {
            return false;
        };
        var configuration = JSON.parse(envelope.message.data);
        pending = true;
        function onSuccess(response) {
            model = response;

            Vendd.MessageBus.publishAsync(Vendd.FilterProduct, new Vendd.FilterProduct.Messages.Changed(model));

            pending = false;
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.FilterProduct, new Vendd.FilterProduct.Messages.Failed(response));
        }

        var options = {
            url: 'AdapterService.svc/GetData' + (location.search),
            data: {
                serviceConfiguration: JSON.stringify(configuration)
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);

        return true;
    });

    
    

    return Vendd;

})(Vendd || {});